<template>
  <div>
    <b-message style="display: flex;">
      <div
        class="thumbnail"
        v-for="photo in photos"
        :key="photo.id"
        @click="showModal(photo)"
      >
        <img :src="photo.thumbnail" class="attachment-image" />
      </div>
    </b-message>

    <b-modal v-if="selectedPhoto" v-model="modalActive">
      <p class="image">
        <img :src="selectedPhoto.url" class="attachment-image-full" style="max-height: 100%;">
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'photo-list',
  props: {
    photos: Array,
  },
  data() {
    return {
      modalActive: false,
      selectedPhoto: null,
    };
  },
  methods: {
    showModal(photo) {
      this.selectedPhoto = photo;
      this.modalActive = true;
    },
  },
};
</script>

<style scoped lang="scss">
  .thumbnail {
    display: inline-block;
    margin: 4px;
    border: 2px #ccc solid;
    cursor: pointer;
  }

  .image {
    text-align: center;
  }

  .attachment-image-full {
    width: auto;
    height: auto;
    max-height: 100%;
    max-width: 100%;
    display: inline-block;
  }
</style>
